import { render } from "./LoaderDots.vue?vue&type=template&id=b93a2036&scoped=true"
import script from "./LoaderDots.vue?vue&type=script&lang=js"
export * from "./LoaderDots.vue?vue&type=script&lang=js"

import "./LoaderDots.vue?vue&type=style&index=0&id=b93a2036&scoped=true&lang=css"

import exportComponent from "/var/www/greenified-mono-staging/ims.greenified.se/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93a2036"]])

export default __exports__